/**
 * Utility functions for generating subdomain-based URLs
 * Works in both server and client environments
 */

// Base URLs - handle both Vite and Node.js environments
const resolveAdminBaseUrl = (): string => {
	if (typeof import.meta.env !== 'undefined' && import.meta.env.VITE_ADMIN_URL) {
		return import.meta.env.VITE_ADMIN_URL;
	}
	if (typeof process !== 'undefined' && process.env?.VITE_ADMIN_URL) {
		return process.env.VITE_ADMIN_URL;
	}
	return 'http://localhost:3000';
};

const resolveRegistrationBaseUrl = (): string => {
	if (typeof import.meta.env !== 'undefined' && import.meta.env.VITE_REGISTRATION_URL) {
		return import.meta.env.VITE_REGISTRATION_URL;
	}
	if (typeof process !== 'undefined' && process.env?.VITE_REGISTRATION_URL) {
		return process.env.VITE_REGISTRATION_URL;
	}
	return 'http://localhost:3000/registration';
};

const resolveDocsUrl = (): string => {
	if (typeof import.meta.env !== 'undefined' && import.meta.env.VITE_DOCS_URL) {
		return import.meta.env.VITE_DOCS_URL;
	}
	if (typeof process !== 'undefined' && process.env?.VITE_DOCS_URL) {
		return process.env.VITE_DOCS_URL;
	}
	return 'https://docs.sunfishevents.com';
};

export const ADMIN_URL = resolveAdminBaseUrl();
export const ADMIN_PATH = '';
export const REGISTRATION_URL = resolveRegistrationBaseUrl();
export const REGISTRATION_PATH = '';
export const DOCS_URL = resolveDocsUrl();

export function adminPath(path: string = ''): string {
	const cleanPath = path.startsWith('/') ? path : `/${path}`;
	return `${ADMIN_PATH}${cleanPath}`;
}

export function registrationPath(path: string = ''): string {
	const cleanPath = path.startsWith('/') ? path : `/${path}`;
	return `${REGISTRATION_PATH}${cleanPath}`;
}

export function getAdminUrl(path: string = '', absolutePath = false): string {
	const cleanPath = path.startsWith('/') ? path : `/${path}`;
	if (absolutePath) {
		return `${ADMIN_URL}${cleanPath}`;
	}
	return adminPath(path);
}

export function landingPagePath(tenantSlug: string, landingSlug: string): string {
	return registrationPath(`/${tenantSlug}/${landingSlug}`);
}

export function getLandingPageUrl(
	tenantSlug: string,
	landingSlug: string,
	flowPath?: string,
	absoluteUrl?: boolean
): string {
	const path = landingPagePath(tenantSlug, landingSlug);
	return `${absoluteUrl !== false ? REGISTRATION_URL : REGISTRATION_PATH}${path}${flowPath ? flowPath : ''}`;
}

export function registrationFlowPath(tenantSlug: string, landingSlug: string, path: string = ''): string {
	const cleanPath = path.startsWith('/') ? path : path ? `/${path}` : '';
	return registrationPath(`/${tenantSlug}/${landingSlug}/register${cleanPath}`);
}

export function getRegistrationUrl(
	tenantSlug: string,
	landingSlug: string,
	path: string = '',
	absoluteUrl: boolean = true
): string {
	const flowPath = registrationFlowPath(tenantSlug, landingSlug, path);
	return `${absoluteUrl ? REGISTRATION_URL : REGISTRATION_PATH}${flowPath}`;
}

export const subdomainUrls = {
	admin: ADMIN_URL,
	registration: REGISTRATION_URL
} as const;
